const getFieldGroupKeys = (measureFieldGroups) => {
    return measureFieldGroups.map((mfg) => mfg.measureFields.map((mf) => mf.modelColumnID)).map((cIds) => cIds.sort().join("|"));
};
exports.getFieldGroupKeys = getFieldGroupKeys;
